import React from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar  navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            style={{ marginTop: "40px" }}
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link className="navbar-brand page-scroll" to="/">
            <img src="/img/logo-b.png" alt="" width="100" />
          </Link>{" "}
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="/#career" className="page-scroll">
                {t("career")}
              </a>
            </li>
            <li>
              <a href="/#contact" className="page-scroll">
                {t("request")}
              </a>
            </li>
            <li>
              <a href="/#testimonials" className="page-scroll">
                {t("our-clients")}
              </a>
            </li>
            <li>
              <a href="/#services" className="page-scroll">
                {t("services")}
              </a>
            </li>

            <li>
              <a href="/#about" className="page-scroll">
                {t("about")}
              </a>
            </li>

            <li>
              <a href="/#features" className="page-scroll">
                {t("values")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
